var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrowGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95171 0.988264C6.66908 1.29108 6.68545 1.76567 6.98826 2.04829C8.05284 3.04498 9.11786 4.08991 10.0072 5.25L0.750071 5.25C0.335858 5.25 2.11379e-07 5.58579 2.29485e-07 6C2.47591e-07 6.41422 0.336424 6.75 0.750637 6.75L10.0072 6.75C9.11745 7.91062 8.05509 8.95288 6.98826 9.95171C6.68545 10.2343 6.66908 10.7089 6.95171 11.0117C7.23433 11.3146 7.70905 11.3308 8.01186 11.0482C9.17124 9.96558 10.31 8.84706 11.2641 7.575C11.5986 7.12896 12 6.58342 12 6C12 5.41658 11.5986 4.87105 11.2641 4.425C10.3158 3.1606 9.16088 2.03082 8.01174 0.951712C7.70893 0.669086 7.23433 0.685451 6.95171 0.988264Z",
    fill: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrowGray);
export default __webpack_public_path__ + "static/media/forwardArrowGray.56f94a808679497e58542f1215025ce2.svg";
export { ForwardRef as ReactComponent };